<template>
    <div class="max-width-content">
        <breadcrumbs>
            <inertia-link href="/blogs">Blog</inertia-link>
            <i class="fad fa-chevron-right"></i>
            Nieuw blog aanmaken
        </breadcrumbs>

        <div class="flex justify-between items-center">
            <div class="flex ">
                <h1 class="text-5xl text-teal-800 mr-1">Nieuw blog aanmaken</h1>
            </div>
        </div>
        <div class="bg-white rounded-lg p-5">
            <blog-form :categories="categories" @submit="submit"></blog-form>
        </div>
    </div>
</template>

<script>
import Layout from "@/admin/Shared/Layout";
import BlogForm from "@/admin/Pages/Blog/BlogForm";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";

export default {
    metaInfo() {
        return { title: "Blog aanmaken" };
    },

    layout: (h, page) => h(Layout, [page]),

    components: {
        Breadcrumbs,
        BlogForm
    },

    props: {
        categories: Array
    },

    data() {
        return {};
    },

    methods: {
        submit(data) {
            this.loading = "submit";
            const url = this.route("admin.blogs.store");
            const options = {
                onFinish: () => {
                    this.loading = false;
                    if (Object.keys(this.$page.props.errors).length === 0) {
                        this.form.image = null;
                    }
                }
            }

            this.$inertia.post(url, data, options)
        }
    }
};
</script>
